import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { CheckCircleIcon } from '@interstate/components/Icons/CheckCircleIcon';
import { ExclamationCircleIcon } from '@interstate/components/Icons/ExclamationCircleIcon';
import { XCircleIcon } from '@interstate/components/Icons/XCircleIcon';
import { StatusValue } from './types';

interface StatusIconProps {
    status: StatusValue.Passed | StatusValue.Failed | StatusValue.Undetermined;
}

export const StatusIcon = ({ status }: StatusIconProps) => {
    const theme = useInterstateTheme();

    switch (status) {
        case StatusValue.Passed:
            return (
                <CheckCircleIcon fontSize="1rem" color={theme.tokens.BaseColorGreen500} data-testid="compliance-verified-icon" />
            );
        case StatusValue.Failed:
            return (
                <ExclamationCircleIcon fontSize="1rem" color={theme.tokens.BaseColorRed500} data-testid="compliance-alert-icon" />
            );
        case StatusValue.Undetermined:
            return <XCircleIcon fontSize="1rem" color={theme.tokens.BaseColorGold500} data-testid="compliance-undetermined-icon" />;
    }
};
